//监管部门的功能
const MoStuDash = () => import("../views/mo-stu-dash.vue");
const MoClazzDash = () => import("../views/mo-clazz-dash.vue");
const MoOrgDash = () => import("../views/mo-org-dash.vue");
const MoFocusOnOrg = () => import("../views/mo-focus-on-org.vue");

const routers = [
    { path: 'home/my/mo/clazz/dash', component: MoClazzDash },
    { path: 'home/my/mo/stu/dash', component: MoStuDash },
    { path: 'home/my/mo/org/dash', component: MoOrgDash },
    {
        path: 'home/my/mo/focus/org', component: MoFocusOnOrg
    }];

export default {
    routers: routers
}